export default "__VITE_ASSET__CCG0bBnZ__"